/* 布局 */
//前台
import Layout from "@views/layout";

const liveserviceitemRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "liveserviceitem",
            name: "LIVESERVICEITEM",
            meta: {
                title: "现场服务项目管理",
                sort: 1,
            },
            component: () => import("@views/business/liveserviceitem/index.vue"),
            redirect: {
                name: "LIVESERVICEITEM_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "LIVESERVICEITEM_LIST",
                    meta: {
                        title: "现场服务项目管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/liveserviceitem/list.vue"),
                },
                                {
                    path: "add",
                    name: "LIVESERVICEITEM_ADD",
                    meta: {
                        title: "新增现场服务项目管理",
                        parentPath: '/business/liveserviceitem/list',
                        operate: true,
                    },
                    component: () => import("@views/business/liveserviceitem/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "LIVESERVICEITEM_EDIT",
                    meta: {
                        title: "编辑现场服务项目管理",
                        parentPath: '/business/liveserviceitem/list',
                        operate: true,
                    },
                    component: () => import("@views/business/liveserviceitem/form.vue"),
                },
                                        ],
    },


        ],
};

export default liveserviceitemRouter;
